<template>
  <div v-if="loading" class="flex h-full justify-center items-center">
    <loading-spinner diameter="64px" />
  </div>

  <alert-badge
      v-else-if="error.title"
      isDanger
      :title="error.title"
      :body="error.body"
      @dismissed="
      () => {
        error.title = ''
        error.body = ''
      }
    "
  />

  <commission-form
      v-else
      :initCommission="initCommission"
      :successMsg="$t('actions.saveChangesSuccess')"
      :submitAction="update"
  />
</template>

<script lang="ts">
import { defineComponent, onBeforeMount, ref } from 'vue'

import { useHTTP } from '@/plugins/http'

import Commission from '@/models/hr/Commission'

// components
import LoadingSpinner from '@/components/LoadingSpinner.vue'
import CommissionForm from '@/views/hr/commissions/CommissionForm.vue'
import AlertBadge from '@/components/AlertBadge.vue'
import { useRoute } from 'vue-router'
import {router} from "@/router";

export default defineComponent({
  name: 'commission',
  components: {
    LoadingSpinner,
    CommissionForm,
    AlertBadge
  },

  setup() {
    const initCommission = ref(new Commission())
    const http = useHTTP()
    const loading = ref(true)
    const error = ref({ title: '', body: '' })

    const route = useRoute()

    onBeforeMount(async () => {
      const url = `${Commission.ENDPOINT}/${route.params.id}`

      try {
        const resp = await http.get<Commission>(url)
        initCommission.value = Commission.from(resp)
      } catch (errorResp) {
        error.value.title = errorResp.title
        error.value.body = errorResp.body
      }

      loading.value = false
    })

    const update = async (commission: Commission) => {
      try {
        const url = `${Commission.ENDPOINT}/${commission.id}`
        const resp = await http.put<Commission>(url, commission)
        initCommission.value = Commission.from(resp)
        router.back()
      } catch (error) {
        return error
      }
    }

    return {
      initCommission,
      loading,
      update,
      error
    }
  }
})
</script>
